<template>
  <div class="flex flex-column">
    <button class="action"  @click="showAppointmentModal">
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#00A1D4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
          <path d="M17 8.5l-7.5 7L7 13"/>
          <path d="M23.5 12c0 6.352-5.15 11.5-11.5 11.5C5.647 23.5.5 18.352.5 12S5.647.5 12 .5C18.35.5 23.5 5.648 23.5 12z"/>
        </g>
      </svg>
      Aika varattu, sulje käsittely
    </button>

    <button class="action"  @click="showCancelModal">
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#00A1D4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
          <path d="M17 8.5l-7.5 7L7 13"/>
          <path d="M23.5 12c0 6.352-5.15 11.5-11.5 11.5C5.647 23.5.5 18.352.5 12S5.647.5 12 .5C18.35.5 23.5 5.648 23.5 12z"/>
        </g>
      </svg>
      Ajanvarausta ei tehty, poista jonosta
    </button>

    <modal v-show="visibleModal == 'appointment'" variant="large" @close="closeModal">
      <template slot="header">Sulje käsittely</template>
      <template slot="body">
        <p class="mb3 mt0 semibold">Kun olet ottanut yhteyttä asiakkaaseen ja varannut hänelle ajan, lisää aika kalenteriin ja sulje käsittely. Tiedot lähetetään asiakkaalle LemmikkiHelppiin.</p>
        <div class="clearfix bg-blue-gray">
          <Datepicker v-model="closeForm.date" required class="col-12 lg-col lg-col-6 p2" maximum-view="day" :disabled-dates="{to: yesterday}" />
          <div class="col-12 lg-col lg-col-6 px3 pt3 pb3">
            <label>
              Kellonaika
              <input v-model="closeForm.time" type="time" required class="col-12 mt1" pattern="[0-9]{2}:[0-9]{2}" />
            </label>
            <label class="mt2">
              Klinikka
              <Select v-model="closeForm.clinic" required class="col-12 mt1" :options="clinics" label="name" :clearable="false" :reduce="clinic => clinic.clinicId" />
            </label>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="mr2">
          <v-button type="button" @click="closeModal">Peruuta</v-button>
        </div>
        <v-button type="button" :disabled="!confirmAppointmentEnabled" variant="primary" @click="closeAppointmentChat">Sulje käsittely</v-button>
      </template>
    </modal>

    <modal v-show="visibleModal == 'cancel'" variant="medium" @close="closeModal">
      <template slot="header">Poista jonosta?</template>
      <template slot="body">
        <p class="mx3 my0 semibold left-align">Haluatko poistaa asiakkaan jonosta ilman ajanvarausta?</p>
        <p class="mx3 mt0 semibold left-align">Asiakkaan ajanvarauspyyntö perutaan.</p>
      </template>
      <template slot="footer">
        <div class="mr2">
          <v-button type="button" @click="closeModal">Peruuta</v-button>
        </div>
        <v-button type="button" variant="primary" @click="cancelAppointmentChat">Poista jonosta</v-button>
      </template>
    </modal>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import Button from '@/components/Button.vue';
import Datepicker from '@/components/Datepicker.vue';
import Select from '@/components/Select.vue';
import Util from '@/util';
import moment from 'moment';

export default {
  name: 'RightFooterAppointment',
  props: {
    chat: Object,
  },
  data () {
    const appointments = this.chat.appointments || [];

    return {
      visibleModal: null,
      yesterday: moment().subtract(1, 'day').toDate(),
      closeForm: {
        date: null,
        time: '',
        clinic: appointments[appointments.length - 1].clinicId,
      },
    };
  },
  components: {
    Modal,
    'v-button': Button,
    Datepicker,
    Select,
  },
  computed: {
    confirmAppointmentEnabled() {
      return this.appointmentTime && this.closeForm.clinic;
    },

    appointmentTime() {
      const {
        date,
        time,
      } = this.closeForm;

      const timeRegex = /^(?<hour>\d{2}):(?<minute>\d{2})$/;
      const timeParts = ((time || "").match(timeRegex) || {}).groups || {};

      const hour = Number.parseInt(timeParts.hour, 10);
      const minute = Number.parseInt(timeParts.minute, 10);

      if (!date || !(hour >= 0 && hour <= 23) || !(minute >= 0 && minute <= 59)) {
        return null;
      }

      const dateMoment = moment(date);

      return moment({
        year: dateMoment.year(),
        month: dateMoment.month(),
        date: dateMoment.date(),
        hour,
        minute,
      }).format("YYYY-MM-DDTHH:mm:ss");
    },

    ...mapGetters({
      clinics: 'clinics',
    }),
  },
  methods: {
    closeAppointmentChat() {
      this.$store.dispatch('closeAppointmentChat', {
        chatId: this.chat.chatId,
        clinicId: this.closeForm.clinic,
        appointmentTime: this.appointmentTime,
      });
      this.closeModal();
    },
    cancelAppointmentChat() {
      this.$store.dispatch('cancelAppointmentChat', {
        chatId: this.chat.chatId,
      });
    },
    showAppointmentModal() {
      this.visibleModal = 'appointment';
    },
    showCancelModal() {
      this.visibleModal = 'cancel';
    },
    closeModal() {
      this.visibleModal = null;
    }
  },
};
</script>

<style scoped>
  .action {
    margin: 0;
    padding: .75rem var(--space-2);
    border: none;
    background: var(--white);
    color: var(--blue);
    font-size: var(--h5);
    text-align: left;
    cursor: pointer;
    border-top: 1px solid var(--gray-4);
  }

  .action svg {
    display: inline-block;
    vertical-align: middle;
    margin-right: .5rem;
  }

  .action:hover,
  .action:active,
  .action:focus { background-color: var(--gray-6) }

  .action:active,
  .action:focus { outline: none }

  .action:disabled,
  .action.disabled {
    cursor: default;
    color: var(--gray-3);
  }
  .action:disabled svg g { stroke: var(--gray-3) }
  .action:disabled:hover,
  .action.disabled:hover {
    background-color: var(--white);
  }
</style>
